import script from "./addSchedule.vue?vue&type=script&setup=true&lang=js"
export * from "./addSchedule.vue?vue&type=script&setup=true&lang=js"

import "./addSchedule.vue?vue&type=style&index=0&id=915ef7ac&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-915ef7ac"]])

export default __exports__